import { IArrangementConfiguration } from '../models/interfaces';

export class ArrangementConfiguration implements IArrangementConfiguration {
    leadCount: number = 0;
    derivedWaveformPresent: boolean = false;
}
